var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1657 6.29303L8.16569 16.293C8.07859 16.3804 7.9751 16.4498 7.86114 16.4971C7.74719 16.5444 7.62501 16.5688 7.50163 16.5688C7.37824 16.5688 7.25606 16.5444 7.14211 16.4971C7.02815 16.4498 6.92466 16.3804 6.83756 16.293L2.46256 11.918C2.37536 11.8308 2.30618 11.7273 2.25899 11.6134C2.21179 11.4994 2.1875 11.3773 2.1875 11.254C2.1875 11.1306 2.21179 11.0085 2.25899 10.8946C2.30618 10.7806 2.37536 10.6771 2.46256 10.5899C2.54977 10.5027 2.6533 10.4335 2.76724 10.3863C2.88118 10.3391 3.0033 10.3148 3.12663 10.3148C3.24995 10.3148 3.37207 10.3391 3.48601 10.3863C3.59995 10.4335 3.70348 10.5027 3.79069 10.5899L7.50241 14.3016L16.8391 4.96647C17.0152 4.79035 17.2541 4.69141 17.5032 4.69141C17.7523 4.69141 17.9911 4.79035 18.1673 4.96647C18.3434 5.14259 18.4423 5.38146 18.4423 5.63053C18.4423 5.8796 18.3434 6.11847 18.1673 6.2946L18.1657 6.29303Z",
    fill: "#98FF7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.d9a979078acc910a0f0b87999ac728dd.svg";
export { ForwardRef as ReactComponent };